// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import moment from 'moment'
import config from './utils/config'
import base from './utils/base'
import request from './utils/request'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
import VueCropper from 'vue-cropper'
Vue.use(VueCropper);
// import VCharts from 'v-charts'
// Vue.use(VCharts);
// import Print from 'vue-print-nb';
// Vue.use(Print);
import iView from 'view-design';
Vue.use(iView, {
    //vue 跟 i18n之间的兼容问题
    i18n: function (path, options) {
        let value = i18n.t(path, options);
        if (value !== null && value !== undefined) {
            return value;
        }
        return ''
    }
});
Vue.locale = () => { };

//css
import 'view-design/dist/styles/iview.css';
import './assets/css/main.css'

//语言包
import zhLocale from "view-design/src/locale/lang/zh-CN";
import twLocale from "view-design/src/locale/lang/zh-TW";
import enLocale from "view-design/src/locale/lang/en-US";
import cn from "./utils/lang/zh-CN";
import tw from "./utils/lang/zh-TW";
import en from "./utils/lang/en";

//语言包
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: base.getLang(),  // 语言标识
    messages: {
        'zh-CN': Object.assign(cn, zhLocale),
        'zh-TW': Object.assign(tw, twLocale),
        'en': Object.assign(en, enLocale)
    }
});
// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel',JsonExcel);

Vue.prototype.$moment = moment;
Vue.prototype.$config = config;
Vue.prototype.$base = base;
Vue.prototype.$request = request;

Vue.config.productionTip = false;
config.i18n = i18n;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js